







































































































































































































































































































































































































































































































































































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import CommonVue from '../models/commonVue';
import { BusEvent } from '../models/bus';
import { MediaFileField } from '../models/fields';

import Exercise from '../api/exercise';
import LockManager from '../models/lock';
import Media from '../api/media';

import FieldAudio from '../components/FieldAudio.vue';
import FieldImage from '../components/FieldImage.vue';
import FieldTranscriptArpabet from '../components/FieldTranscriptArpabet.vue';
import FieldSentenceLinks from '../components/FieldSentenceLinks.vue';
import FieldInternational from '../components/FieldInternational.vue';
import FieldVideos from '../components/FieldVideos.vue';
import FieldPhonemes from '../components/FieldPhonemes.vue';
import FieldHints from '../components/FieldHints.vue';
import FieldVideosI18n from '../components/FieldVideosI18n.vue';
import EditIcon from '../components/icons/EditIcon.vue';
import FieldAlternateSentence from '../components/FieldAlternateSentence.vue';
import FieldNextExercise from '../components/FieldNextExercise.vue';
import FieldAltNextExercise from '@/components/FieldAltNextExercise.vue';
import FieldReferenceAlignments from '@/components/FieldReferenceAlignments.vue';
import FieldExtraInfo from '@/components/FieldExtraInfo.vue';
import FieldExtraLine from '@/components/FieldExtraLine.vue';
import CopyExercise from '@/components/CopyExercise.vue';
import Module from '@/api/module';
import { isEmpty, isNil } from 'lodash';
import { checkContent } from '@/api/content-check';

@Component({
  components: {
    'field-extra-line': FieldExtraLine,
    'field-extra-info': FieldExtraInfo,
    'field-reference-alignments': FieldReferenceAlignments,
    'field-audio': FieldAudio,
    'field-image': FieldImage,
    'field-transcript-arpabet': FieldTranscriptArpabet,
    'field-sentence-links': FieldSentenceLinks,
    'field-international': FieldInternational,
    'field-videos': FieldVideos,
    'field-videos-i18n': FieldVideosI18n,
    'field-phonemes': FieldPhonemes,
    'field-hints': FieldHints,
    'edit-icon': EditIcon,
    'field-alternate-sentence': FieldAlternateSentence,
    'field-next-exercise': FieldNextExercise,
    'copy-exercise': CopyExercise
  }
})
export default class EditExerciseConversation extends CommonVue {
  @Prop({ type: Number }) public moduleId!: number;
  @Prop({ type: Number }) public lessonId!: number;
  @Prop({ type: Exercise }) public exercise!: Exercise;
  public isCheckAudioConversation: boolean = undefined;
  public isCheckAudioSpeaking: boolean = undefined;
  @Prop({ type: String, default: Module.SLUG }) public parent!: string;

  public async beforeMount() {
    await this.load();
  }

  @Watch('exercise')
  public async load() {
    this.busy = true;
    this.error = false;

    if (this.exercise && this.exercise.id) {
      this.lockManager = new LockManager(this.EXERCISE_SLUG, this.exercise.id);
      await this.lockManager.checkStatus();
      if (this.lockManager.isBusy) {
        this.$bus.$emit(
          BusEvent.ERROR,
          'Someone else is making changes.',
          new Error(
            'Click refresh to check if they have finished their changes'
          )
        );
      }
    } else {
      this.lockManager = null;
    }

    this.busy = false;
  }

  // enter edit mode if it can get the lock
  @Watch('exercise', { deep: true })
  public async enterEditMode() {
    await this.tryToLock();
  }

  public async deleteClicked(): Promise<void> {
    if (!this.exercise || !this.exercise.id) {
      return;
    }

    this.busy = true;
    this.exercise.isDirty = false;

    try {
      if (!this.lockManager) {
        this.lockManager = new LockManager(
          this.EXERCISE_SLUG,
          this.exercise.id
        );
      }

      await this.tryToLock();

      await this.exercise.delete();

      await this.lockManager.releaseLock();

      this.busy = false;
      this.$router.push(
        `/${this.parent}/${this.moduleId}/${this.LESSON_SLUG}/${this.lessonId}/${this.EXERCISE_SLUG}`
      );
    } catch (e) {
      this.busy = false;
      this.$bus.$emit(BusEvent.ERROR, 'Could not delete exercise', e);
    }
  }

  public async saveClicked(): Promise<void> {
    if (!this.exercise) {
      return;
    }

    this.busy = true;
    this.exercise.isDirty = false;

    try {
      this.checkMandatoryFields();
      await this.saveExercise();
      this.busy = false;

      const isContentOkay = await this.performContentCheck();
      if (!isContentOkay) return;

      this.$router.push(
        `/${this.parent}/${this.moduleId}/${this.LESSON_SLUG}/${this.lessonId}/${this.EXERCISE_SLUG}`
      );
    } catch (e) {
      this.busy = false;
      console.log(e);
      this.$bus.$emit(BusEvent.ERROR, 'Could not save exercise', e);
    }
  }

  public async performContentCheck() {
    const data = await Exercise.getJson(this.exercise.id);
    const result = await checkContent(data);

    if (isEmpty(result.result)) {
      return true;
    }

    this.$bus.$emit(BusEvent.ERROR, 'Could not save exercise', {
      messageItems: result.result.map((item) => ({
        message: item.message,
        key: item.word || item.sentence
      }))
    });

    return false;
  }

  private isValidInput(sentence: string, audio: MediaFileField, isElsa = true) {
    if (sentence === undefined || sentence === '') {
      return false;
    }

    // Check if conversation audio was chosen
    if (!audio.hasMedia()) {
      return false;
    }

    return true;
  }

  public checkMandatoryFields() {
    const isElsaInputValid = this.isValidInput(
      this.exercise.conversation_content.sentence,
      this.$refs.conversation_audio as MediaFileField,
      true
    );

    const isUserInputValid = this.isValidInput(
      this.exercise.speaking_content.sentence,
      this.$refs.speaking_audio as MediaFileField,
      true
    );

    if (!isElsaInputValid && !isUserInputValid) {
      throw Error(
        'Both Elsa and User sentences/audio are missing. You must input sentence/audio file for ELSA Speaking or User Speaking'
      );
    }
  }

  public async checkConversationAudio(): Promise<void> {
    this.busy = true;
    this.exercise.isDirty = false;

    try {
      const isElsaInputValid = this.isValidInput(
        this.exercise.conversation_content.sentence,
        this.$refs.conversation_audio as MediaFileField,
        true
      );
      if (!isElsaInputValid) {
        throw Error(
          'Elsa sentence/audio are missing. You must input sentence/audio file for ELSA'
        );
      } else {
        const result = await this.exercise.checkAudioConversation();
        if (result && result.stream_score_type === 'correct') {
          if (!isNil(this.exercise.conversation_content.transcription)) {
            this.exercise.conversation_content.transcription = result.sentence_ipa
              ? result.sentence_ipa
              : '';
          }
          this.isCheckAudioConversation = true;
          setTimeout(() => {
            this.isCheckAudioConversation = undefined;
            console.log(
              'this.isCheckAudioConversation',
              this.isCheckAudioConversation
            );
          }, 1000);
        } else {
          this.isCheckAudioConversation = false;
          setTimeout(() => (this.isCheckAudioConversation = undefined), 1000);
        }
      }
      this.busy = false;
    } catch (e) {
      this.busy = false;
      this.$bus.$emit(BusEvent.ERROR, 'Could not check audio', e);
    }
  }

  public async checkSpeakingAudio(): Promise<void> {
    this.busy = true;
    this.exercise.isDirty = false;

    try {
      const isUserInputValid = this.isValidInput(
        this.exercise.speaking_content.sentence,
        this.$refs.speaking_audio as MediaFileField,
        true
      );
      if (!isUserInputValid) {
        throw Error(
          'User sentence/audio are missing. You must input sentence/audio file for User Speaking'
        );
      } else {
        const result = await this.exercise.checkAudioSpeaking();
        if (result && result.stream_score_type === 'correct') {
          if (!isNil(this.exercise.speaking_content.transcription)) {
            this.exercise.speaking_content.transcription = result.sentence_ipa
              ? result.sentence_ipa
              : '';
          }
          this.isCheckAudioSpeaking = true;
          setTimeout(() => {
            this.isCheckAudioSpeaking = undefined;
            console.log('this.isCheckAudioSpeaking', this.isCheckAudioSpeaking);
          }, 1000);
        } else {
          this.isCheckAudioSpeaking = false;
          setTimeout(() => (this.isCheckAudioSpeaking = undefined), 1000);
        }
      }
      this.busy = false;
    } catch (e) {
      this.busy = false;
      this.$bus.$emit(BusEvent.ERROR, 'Could not check audio', e);
    }
  }

  public async saveExercise() {
    let lessonLockManager: LockManager;

    if (!this.exercise.id) {
      lessonLockManager = new LockManager(this.LESSON_SLUG, this.lessonId);
      await lessonLockManager.tryAcquireLock();

      // Upload exercise
      await this.exercise.save();

      // call it again to save media files of content
      await this.saveExercise();
    } else {
      if (!this.lockManager) {
        this.lockManager = new LockManager(
          this.EXERCISE_SLUG,
          this.exercise.id
        );
      }
      await this.tryToLock();
      // ALT
      await this.saveSpeakingAltContent();

      if (!this.exercise.conversation_content.id) {
        this.exercise.conversation_content.parent_exercise = this.exercise.id;
        await this.exercise.conversation_content.save();
      }
      if (!this.exercise.speaking_content.id) {
        this.exercise.speaking_content.parent_exercise = this.exercise.id;
        await this.exercise.speaking_content.save();
      }

      await FieldHints.saveHints(
        this.exercise.speaking_content.global_hints_objects,
        this.exercise.speaking_content.id,
        'exercisespeakingcontent'
      );

      // Upload contents with media ids
      await this.saveMediaFiles();
      await FieldNextExercise.saveNextExercises(
        this.exercise.speaking_content.next_exercise_objects,
        this.exercise.speaking_content.id,
        'exercisespeakingcontent'
      );
      // await this.exercise.updateReferenceScore();
      await FieldExtraLine.saveExtraLines(
        this.exercise.speaking_content.extra_lines_objects,
        this.exercise.speaking_content.id,
        'exercisespeakingcontent'
      );
      await FieldExtraLine.saveExtraLines(
        this.exercise.conversation_content.extra_lines_objects,
        this.exercise.conversation_content.id,
        'exerciseconversationcontent'
      );
      await this.exercise.speaking_content.save();
      await this.exercise.conversation_content.save();
      await this.exercise.save();
    }
    const bg_image = await this.saveMediaFile(
      this.$refs.bg_image_path,
      'bg_image_path',
      ''
    );
    if (bg_image) {
      this.exercise.bg_image_path = bg_image;
      await this.exercise.save();
    }

    if (this.lockManager && !this.lockManager.isAvailable) {
      await this.lockManager.releaseLock();
    }
    if (lessonLockManager) {
      await lessonLockManager.releaseLock();
    }
  }

  public async saveSpeakingAltContent() {
    for (const speaking_alt_content of this.exercise
      .speaking_alt_content_objects) {
      if (speaking_alt_content.state === 'updated') {
        await this.saveSpeakingAltContentMedia(speaking_alt_content);
        if (!speaking_alt_content.id) {
          speaking_alt_content.parent_exercise = this.exercise.id;
          await speaking_alt_content.save();
        }

        await FieldAltNextExercise.saveNextExercises(
          speaking_alt_content.next_exercise_objects,
          speaking_alt_content.id,
          'exercisespeakingaltcontent'
        );
        await FieldHints.saveHints(
          speaking_alt_content.global_hints_objects,
          speaking_alt_content.id,
          'exercisespeakingaltcontent'
        );
        await speaking_alt_content.save();
      } else if (
        speaking_alt_content.state === 'deleted' &&
        speaking_alt_content.id
      ) {
        await speaking_alt_content.delete();
      }
    }
  }

  public async saveMediaFiles(): Promise<void> {
    if (!this.exercise || !this.exercise.id) {
      throw Error('Exercise has not been created yet.');
    }

    this.imagesToDelete.forEach((id) => Media.deleteImage(id));
    this.imagesToDelete = [];

    this.audioToDelete.forEach((id) => Media.deleteAudio(id));
    this.audioToDelete = [];

    const conversation_audio = await this.saveMediaFile(
      this.$refs.conversation_audio,
      'audio_path',
      'conversation'
    );
    if (conversation_audio !== null) {
      this.exercise.conversation_content.audio_path = conversation_audio;
    }
    const conversation_audio_alt = await this.saveMediaFile(
      this.$refs.conversation_audio_alt,
      'audio_alt_path',
      'conversation'
    );
    if (conversation_audio_alt !== null) {
      this.exercise.conversation_content.audio_alt_path = conversation_audio_alt;
    }
    const image = await this.saveMediaFile(
      this.$refs.image,
      'image_path',
      'conversation'
    );
    if (image !== null) {
      this.exercise.conversation_content.image_path = image;
    }
    const speaking_audio = await this.saveMediaFile(
      this.$refs.speaking_audio,
      'audio_path',
      'speaking'
    );
    if (speaking_audio !== null) {
      this.exercise.speaking_content.audio_path = speaking_audio;
    }
    const speaking_audio_alt = await this.saveMediaFile(
      this.$refs.speaking_audio_alt,
      'audio_alt_path',
      'speaking'
    );
    if (speaking_audio_alt !== null) {
      this.exercise.speaking_content.audio_alt_path = speaking_audio_alt;
    }
    const speaking_image = await this.saveMediaFile(
      this.$refs.speaking_image,
      'image_path',
      'speaking'
    );
    if (speaking_image !== null) {
      this.exercise.speaking_content.image_path = speaking_image;
    }
  }

  public async saveSpeakingAltContentMedia(
    speaking_alt_content
  ): Promise<void> {
    if (speaking_alt_content.audio_file) {
      const audio = await Media.createAudio(
        speaking_alt_content.audio_file,
        this.EXERCISE_SLUG,
        this.exercise.id,
        'audio_path'
      );
      if (audio !== null) {
        speaking_alt_content.audio_path = audio;
      }
    } else if (speaking_alt_content.audio_file === null) {
      await Media.deleteAudio(speaking_alt_content.audio_path);
      speaking_alt_content.audio_path = undefined;
    }
    if (speaking_alt_content.audio_alt_file) {
      const audio_alt = await Media.createAudio(
        speaking_alt_content.audio_alt_file,
        this.EXERCISE_SLUG,
        this.exercise.id,
        'audio_alt_path'
      );
      if (audio_alt !== null) {
        speaking_alt_content.audio_alt_path = audio_alt;
      }
    } else if (speaking_alt_content.audio_alt_file === null) {
      await Media.deleteAudio(speaking_alt_content.audio_alt_path);
      speaking_alt_content.audio_alt_path = undefined;
    }
    if (speaking_alt_content.image_file) {
      const image = await Media.createImage(
        speaking_alt_content.image_file,
        this.EXERCISE_SLUG,
        this.exercise.id,
        'image_path'
      );
      if (image !== null) {
        speaking_alt_content.image_path = image;
      }
    } else if (speaking_alt_content.image_file === null) {
      await Media.deleteAudio(speaking_alt_content.image_path);
      speaking_alt_content.image_path = undefined;
    }
  }

  public async saveMediaFile(
    field: any,
    fieldName: string,
    type: string
  ): Promise<number | null | undefined> {
    if (!this.exercise || !this.exercise.id) {
      return null;
    }
    const mediaFileField = (field as any) as MediaFileField;
    if (mediaFileField.hasNewMedia()) {
      switch (type) {
        case 'conversation': {
          return await mediaFileField.upload(
            'exerciseconversationcontent',
            this.exercise.conversation_content.id,
            fieldName
          );
        }
        case 'speaking': {
          return await mediaFileField.upload(
            'exercisespeakingcontent',
            this.exercise.speaking_content.id,
            fieldName
          );
        }
        default: {
          return await mediaFileField.upload(
            this.EXERCISE_SLUG,
            this.exercise.id,
            fieldName
          );
        }
      }
    } else if (!mediaFileField.hasMedia()) {
      return undefined;
    } else {
      return null;
    }
  }

  public async jsonView(): Promise<void> {
    this.$router.push(`/json/${this.exercise.id}`);
  }

  public async getReferenceScore(): Promise<void> {
    try {
      this.checkMandatoryFields();
      await this.exercise.updateReferenceScore();
    } catch (e) {
      this.busy = false;
      this.$bus.$emit(BusEvent.ERROR, 'Could not update score exercise', e);
    }
  }
}
